<template>
  <div class="meeting-detail" v-loading="loading">
    <div class="container1">
      <div class="meeting-detail-div">
        <div class="meeting-detail-left">
          <template v-if="data.coverImageUrl">
            <img :src="data.coverImageUrl">
          </template>
          <template v-else>
            <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/meeting_default_image.png">
          </template>

        </div>
        <div class="meeting-detail-right">
          <div class="meeting-detail-title">{{ data.enActivityTheme }}</div>
          <div class="meeting-detail-date">
            <span style="margin-right: 4px;">Time:</span>
            <span>
              <span style="margin-right: 8px;">{{ data.activityStartDate | formatDate('y-m-d') }}</span>
              <!-- <span style="color: #009A6D;">{{ data.activityStartDate | formatDate('hours') }}</span> -->
            </span>
          </div>
          <div class="meeting-detail-btn">
            <el-button size="small" type="primary" @click.stop="goSignUp(data)">Application</el-button>
          </div>
          <div class="meeting-detail-desc">
            <template v-if="data.enIntroduceList">
              <div class="remark-item" v-for="(item, index) in data.enIntroduceList" :key="item">
                {{ item }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { activityQueryDetail } from '@/api'
export default {
  data() {
    return {
      loading: true,
      data: {}
    }
  },
  mounted() {
    this.getData()

    console.log('this.$router----->', this.$route.params.id)
  },
  methods: {
    // 报名
    goSignUp(item) {
      console.log('item------>', item)
      if (item.activeUrl) {
        window.open(item.activeUrl, '_blank')
      }
    },
    // 获取数据列表
    async getData() {
      this.loading = true
      const res = await activityQueryDetail({ id: this.$route.params.id })
      if (res.data.code == 1000) {
        let data = res.data?.data?.activity || {}
        if (data.enIntroduce) {
          data.enIntroduceList = data.enIntroduce.split("\n")
        }
        this.data = data
      }
      this.loading = false
    },
  }
    
  }
</script>

<style lang="stylus" scoped>
.meeting-detail {
  padding: 208px 10px 50px 10px;
  .container1{
    max-width: 1366px;
    margin: 0 auto;
    background: #fff;
    padding:16px;
    height:auto;
  }
  .meeting-detail-left{
    flex-shrink: 0;
    width: 624px;
    height:320px;
    margin-right:17px;
    margin-bottom:0px;
    img{
      width:100%;
      height: 100%
    }
  }
  .meeting-detail-right{
    flex-grow: 1;
  }
  .meeting-detail-title{
    font-weight: 600;
    font-size: 24px;
    color: rgba(0,0,0,0.85);
    line-height: 24px;
    margin-bottom:12px;
  }
  .meeting-detail-name{
    font-weight: 400;
    font-size: 16px;
    color: rgba(66,66,66,0.45);
    line-height: 16px;
    margin-bottom:16px;
  }
  .meeting-detail-date{
    font-weight: 400;
    font-size: 16px;
    color: rgba(66,66,66,0.65);
    line-height: 16px;
    margin-bottom:20px;
  }
  .meeting-detail-tips{
    font-weight: 600;
    font-size: 16px;
    color: rgba(0,0,0,0.65);
    line-height: 16px;
    margin-bottom:10px;
  }
  .meeting-detail-desc{
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.45);
    line-height: 24px;
  }
  .meeting-detail-btn{
    margin-bottom:24px;
  }
}
</style>

<style lang="scss" scoped>
.meeting-detail-div {
  display: flex;
  justify-content: space-between;
}
.remark-item{
  width: 100%;
  min-height: 24px;
}

@media (min-width: 320px) and (max-width: 750px) {
  .meeting-detail-div {
    display: block;
  }
  .meeting-detail {
    .meeting-detail-left {
      flex-shrink: 0;
      width: auto;
      height: auto;
      margin-bottom: 17px;
      margin-right: 0;
      img {
        width: 100%;
        height: 100%
      }
    }

    .meeting-detail-title {
      font-size: 16px;
      line-height: 16px;
    }

    .meeting-detail-name {
                font-weight: 600;
    }

    .meeting-detail-date {
      font-size: 14px;
        line-height: 14px;
    }

    .meeting-detail-tips {
      font-size: 14px;
      line-height: 14px;
    }

    .meeting-detail-desc {
      font-size: 12px;
      line-height: 20px;
    }

  }
}
</style>